/* Carbon Society Co. - scroll reveals (pairs with cs-motion.css).
 * Marks section headings, cards and key blocks with data-reveal and fades them up once as they
 * enter the viewport. Content already on screen is shown immediately. Skipped entirely for
 * reduced motion or browsers without IntersectionObserver, so content is never left hidden.
 */
(function () {
  if (!window.matchMedia || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;
  var doc = document.documentElement;
  var SEL = [
    /* Product cards are excluded: their photos use multiply blending, which a fade would break */
    '.section-head', '.page-head',
    '.grid > .card--build', '.grid > .card--text', '.mk-grid > .mk', '.trust__item', '.fjt__step', '.material',
    '.ledf__media', '.ledf__content', '.about__media', '.about__content',
    '.faq-preview__list', '.faq__item', '.newsletter .container', '.footer__grid > *'
  ].join(',');
  var targets = [], groupCount = new Map();
  document.querySelectorAll(SEL).forEach(function (el) {
    if (el.closest('.cs-hero, .header, .menu-toggle, .cc, [data-reveal]')) return;
    var parent = el.parentNode, n = groupCount.get(parent) || 0;
    groupCount.set(parent, n + 1);
    el.setAttribute('data-reveal', '');
    if (n) el.style.setProperty('--reveal-delay', Math.min(n, 6) * 70 + 'ms');
    targets.push(el);
  });
  if (!targets.length) return;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });
  targets.forEach(function (el) {
    var r = el.getBoundingClientRect();
    if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('is-in'); else io.observe(el);
  });
  doc.classList.add('cs-anim');
  function showAll() { targets.forEach(function (el) { el.classList.add('is-in'); }); }
  window.addEventListener('beforeprint', showAll);
  window.addEventListener('hashchange', showAll);
})();
